<template>
    <div>
        <v-tooltip right :lazy="lazy">
            <slot name="activator" slot="activator"></slot>
            <div class="sfr-tooltip-content">
                <div v-for="field in mappedEntry.fields">
                    <div v-if="isReferenceField(field)">
                        <div v-if="isMultipleReferenceField(field)">
                            <div class="tooltip-row">
                                <span class="field-name">{{getNameByIdentifier(field.identifier)}}: </span>
                                <span>{{referenceNonMediaAllowsMultipe(field)}}</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="tooltip-row">
                                <span class="field-name">{{getNameByIdentifier(field.identifier)}}: </span>
                                <span v-if="fieldToReferenceEntryOfType(field)">
                            <div v-if="isMediaField(field)">
                                <div v-if="getMediaTypeOfEntry(fieldToReferenceEntryOfType(field)).category === 'Image'">
                                    <img :src="getUrlField(fieldToReferenceEntryOfType(field).fields).value" alt="hello"
                                         class="reference-thumbnail">
                                </div>
                                <div v-else>
                                    <font-awesome-icon
                                            v-if="getMediaTypeOfEntry(fieldToReferenceEntryOfType(field)).category === 'Audio'"
                                            :icon="['fal', 'file-audio']" size="2x"
                                            class="category-icon"/>
                                    <font-awesome-icon
                                            v-else-if="getMediaTypeOfEntry(fieldToReferenceEntryOfType(field)).category === 'PDF'"
                                            :icon="['fal', 'file-pdf']" size="2x"
                                            class="category-icon"/>
                                    <font-awesome-icon
                                            v-else-if="getMediaTypeOfEntry(fieldToReferenceEntryOfType(field)).category === 'Video'"
                                            :icon="['fal', 'file-video']" size="2x"
                                            class="category-icon"/>
                                    <span>{{getUrlField(fieldToReferenceEntryOfType(field).fields).value}}</span>

                                </div>
                            </div>
                            <span v-else>{{getPrimaryDisplayName(fieldToReferenceEntryOfType(field))}}</span>
                        </span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="tooltip-row">
                            <span class="field-name">{{getNameByIdentifier(field.identifier)}}: </span>
                            <span>{{field.value}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </v-tooltip>
    </div>

</template>

<script>
    import BaseLoadingComponent from '../BaseLoading'
    import {fieldTypesMixin} from '../../mixins/FieldTypes'

    import {
        CONTENT_TYPE_ASSET,
    } from '../../services/constants'
    import helpers from '../../services/helpers'
    import lodash from "../../services/lodash"

    export default {
        name: 'sfr-entry-tooltip',
        extends: BaseLoadingComponent,
        mixins: [fieldTypesMixin],
        props: {
            entry: Object,
            lazy: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            mappedEntry() {
                return this.entry ? helpers.buildIncomingObj(lodash.cloneDeep(this.entry)) : null
            },
            allStoreReferenceContent() {
                return this.$store.state.spaceContent
            },
        },
        methods: {
            isMediaField(field) {
                return field.referenceType === CONTENT_TYPE_ASSET
            },
            getNameByIdentifier(identifier) {
                return helpers.getNameByIdentifier(this.entry.contentType, identifier)
            },
            fieldToReferenceEntryOfType(field) {
                const refValue = field.value
                if (this.allStoreReferenceContent) {
                    const referenceContent = this.allStoreReferenceContent[field.referenceType]
                    if (referenceContent) {
                        const result = referenceContent.find(entry => {
                            return entry.id === Number(refValue)
                        })
                        return result
                    }
                }
                return null
            },

            referenceNonMediaAllowsMultipe(field) {
                return field.value
                    .map(this.fieldToReferenceEntryOfType)
                    .map(this.getPrimaryDisplayName)
                    .join(', ')
            },

            getMediaTypeOfEntry(entry) {
                return helpers.getMediaTypeOfEntry(entry, this.$store.state)
            },
            getUrlField: function (fields) {
                return fields.find(field => {
                    return field.identifier === 'url'
                })
            },
            getPrimaryDisplayName: helpers.getPrimaryDisplayName,

        },
        created: function () {
        }
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .sfr-tooltip-content {
        /*padding: 0 5em 0 0;*/
        min-width: 350px;
        max-width: 600px;
    }

    .field-name {
        font-weight: bold;
    }

    .reference-thumbnail {
        $size: 100px;
        max-height: $size;
        max-width: $size;
        vertical-align: middle;
        margin: 0 1em 0 0;
    }

    .category-icon {
        margin: 0 .5em 0 0;
    }

    .tooltip-row {
        font-size: 16px;
        margin: 1em;
    }


</style>
